import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";


const MachineCharacteristics = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "characteristic", label: "Caracteristica", type: "text", required: true, displayForm: true, displayList: true },
  ];

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Caracteristicas de maquina
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList fields={fieldsConfig} tableName="machine_characteristics" hasCheckbox={true} objectName={"machine characteristic"} tabledescription={"Caracteristicas"}/>
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default MachineCharacteristics;
